import React, { Component } from "react";
import map from "lodash/map";
import find from "lodash/find";
import { isEmpty } from "lodash";
import moment, { invalid } from "moment-timezone";
import * as yup from "yup";
import { Select, DatePicker, message } from "antd";
import Script from "react-load-script";
import Sidebar from "./Sidebar";
import map_icon from "../../../Assets/images/map_icon.svg";
import chevron from "../../../Assets/images/chevron.svg";
import plus_icon from "../../../Assets/images/plus_icon.svg";
import cross_icon from "../../../Assets/images/cross_icon.svg";
import { AllState } from "../../../Assets/data/stateList.json";
import { errorHandle } from "../../Common/errorHandle";
import AcceptedCards from "../../../Assets/images/credit-cards.png";
import BankAccount from "../../../Assets/images/BankAccountImage.svg";
import BankAccountDetails from "../../Common/Component/BankAccountDetails";
import CreditCard from "../../Common/Component/CreditCard";
import axios from "axios";
import config from "../../../Lib/config";
import AddressEntry from "../../Common/Addressentry";
const { Option } = Select;
class Step2 extends Component {
  fattJs = null;
  google_address_input_id = "google_address";

  constructor(props) {
    super(props);
    this.state = {
      is_overwrite: false,
      autocomplete: null,
      PrefDate: "",
      service_address: {
        address: "",
        state: "",
        city: "",
        zip_code: "",
        geo_location: { latitude: null, longitude: null },
      },
      billing_address: {
        address: "",
        state: "",
        city: "",
        zip_code: "",
        geo_location: { latitude: null, longitude: null },
      },
      preferred_start_date: null,
      display_preferred_start_date: null,
      is_address_manually: false,
      is_billing_address_same: true,
      first_name: "",
      last_name: "",
      email: "",
      preferred_contact_methods: [],
      service_add_ons: [],
      single_contact: { uuid: "", primary: true, type: "mobile" },
      multiple_concact: [],
      ZipcodeCheck: [],
      errors: {},
      is_checkout_btn_active: false,
      is_checkout_mobile_btn_active: false,
      is_ternm_accepted: false,
      cardNumber: "",
      hideEmailError: true,
      is_mobile: false,
      is_login_user: false,
      is_authorize_charge_each_month: false,
      preferred_days: [],
      credit_card_info: {},
      bank_account_info: {},
      card_number: "",
      card_expiry_month: "",
      card_expiry_year: "",
      card_cvv: "",
      country: "",
      stax_customer: "",
      is_order_placed: false,
      registered_email: "",
      displayCard: false,
      displayBank: true,
      checked_permissions: true,
      checked_permissions_ach: true,
      stax_public_apikey: "",
      stax_card_token: ""
    };
  }

  UNSAFE_componentWillMount = () => {
    const zipcode = JSON.parse(sessionStorage.getItem("area"));
    const step1 = JSON.parse(sessionStorage.getItem("step1"));
    let user = JSON.parse(localStorage.getItem("userKey"));
    const is_overwrite = JSON.parse(sessionStorage.getItem("is_lead"));
    const lead = JSON.parse(sessionStorage.getItem("lead"));

    if (is_overwrite) {
      this.props.getLeadById(lead);
    }

    if (zipcode) {
      this.props.checkZipCode({
        addressable_zip_codes__contains: zipcode["zipcode"],
      });
    }
    if (step1) {
      this.props.getPreferredDays({
        zip_code: zipcode["zipcode"],
        franchises_uuid: step1["field_office_uuid"],
      });
    }

    if (user) {
      this.props.getAccountInfo();
    }
    window.scrollTo(0, 0);
    var self = this;
    setTimeout(() => {
      this.updateDimensions();
      window.addEventListener("resize", self.updateDimensions.bind(self));
    }, 500);

    const temp = JSON.parse(sessionStorage.getItem("email"));
    this.setState({ email: temp ? temp : "", registered_email: temp });
    this.setState({
      is_overwrite,
      loader: false,
    });
    const temp_stax_public_apikey =
      !isEmpty(this.props.ZipcodeCheck) &&
      !isEmpty(this.props.ZipcodeCheck.data) &&
      !isEmpty(this.props.ZipcodeCheck.data.results)
        ? this.props.ZipcodeCheck.data.results[0].stax_public_apikey
        : null;
    this.setState({ stax_public_apikey: temp_stax_public_apikey });
  };

  //componentDidMount
  componentDidMount = () => {
    const temp = JSON.parse(sessionStorage.getItem("email"));
    this.setState({ registered_email: temp, email: temp });
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.is_address_manually && !prevState.is_address_manually) {
      document.getElementById(this.google_address_input_id).value = "";
    }
  };

  UNSAFE_componentWillReceiveProps = (props) => {
    let is_edit = JSON.parse(localStorage.getItem("is_edit"));
    let user = JSON.parse(localStorage.getItem("userKey"));

    if (Object.keys(props.ZipcodeCheck.data).length) {
      this.setState({
        ZipcodeCheck: props.ZipcodeCheck.data.results
          ? props.ZipcodeCheck.data.results
          : [],
      });
    }

    if (Object.keys(props.OrderSubmit.data).length) {
      this.setState({
        loader: false,
      });
      if (is_edit && is_edit.is_edit) {
        window.location.assign("/account");
        localStorage.removeItem("is_property_type");
      } else {
        props.history.push("/doginfo");
      }
    }

    if (
      Object.keys(props.OrderSubmit.errors).length &&
      props.OrderSubmit.errors !== this.props.OrderSubmit.errors
    ) {
      this.setState({
        loader: false,
      });
      if (props.OrderSubmit.errors?.email) {
        message.error(props.OrderSubmit.errors?.email, 10);
      } else if (Array.isArray(props.OrderSubmit?.errors)) {
        map(props.OrderSubmit?.errors, (item) => {
          message.error(item, 10);
        });
      } else {
        errorHandle(props?.OrderSubmit?.errors);
      }
    }

    if (Object.keys(props.AccountInfo.data).length) {
      if (user) {
        let single_contact = [];
        let multiple_concact = [];

        map(
          props.AccountInfo.data.phone_numbers &&
            props.AccountInfo.data.phone_numbers,
          (item, i) => {
            if (item.primary) {
              single_contact = props.AccountInfo.data.phone_numbers[i];
            } else {
              multiple_concact.push(props.AccountInfo.data.phone_numbers[i]);
            }
          }
        );
        this.setState({
          first_name: user.user.first_name,
          last_name: user.user.last_name,
          email: user.user.email,
          single_contact: single_contact,
          multiple_concact,
          is_login_user: true,
        });
      }
    }

    if (Object.keys(props?.ResRegister?.data).length) {
      this.setState({ hear_about_us: props.ResRegister.data.hear_about_us });
      sessionStorage.setItem(
        "hear_about_us",
        props.ResRegister.data.hear_about_us
      );
    }

    if (
      Object.keys(props?.PreferredDays.data).length > 0 &&
      props.PreferredDays.data !== this.props.PreferredDays.data
    ) {
      this.setState({
        loader: false,
        preferred_days: props?.PreferredDays?.data?.data,
      });
    }

    // get geocode
    if (
      Object.keys(props?.GoogleApi?.getGeocode) &&
      JSON.stringify(props?.GoogleApi?.getGeocode) !==
        JSON.stringify(this.props?.GoogleApi?.getGeocode)
    ) {
      this.setAddress(props?.GoogleApi?.getGeocode);
    }

    if (
      props?.errors &&
      Object.keys(props?.errors).length > 0 &&
      JSON.stringify(props?.errors) !== JSON.stringify(this.props?.errors)
    ) {
      message.error("Somenthing went worng");
    }
  };

  // Calculate dimensions
  updateDimensions() {
    var self = this;
    if (window.innerWidth <= 500) {
      //true
      self.setState({
        is_mobile: true,
      });
    } else {
      self.setState({
        is_mobile: false,
      });
    }
  }

  // store in local
  storeInLocal = () => {
    const { service_address } = this.state;
    sessionStorage.setItem("step2", JSON.stringify({ service_address }));
  };

  // set address
  setAddress = (addressObject) => {
    const { is_billing_address_same } = this.state;
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        let obj = {},
          components = addressObject?.results?.[0];
        const zipcode = JSON.parse(sessionStorage.getItem("area"));
        let postal_code = find(components?.address_components, (a) => {
          if (a.types.includes("postal_code")) {
            return a.short_name;
          }
        });
        console.warn(
          `%c postal_code ${postal_code?.short_name}`,
          "font-size: 12px; color: red"
        );
        console.warn(
          `%c zipcode ${zipcode["zipcode"]}`,
          "font-size: 12px; color: green"
        );
        map(components?.address_components, (item) => {
          if (item?.types?.includes("administrative_area_level_2")) {
            obj = Object.assign(obj, { address: item.short_name });
          }
          if (item?.types?.includes("route")) {
            obj = Object.assign(obj, { route: item.short_name });
          }
          if (item?.types?.includes("street_number")) {
            obj = Object.assign(obj, { street_number: item.short_name });
          }
          if (item?.types?.includes("administrative_area_level_1")) {
            obj = Object.assign(obj, { state: item.short_name });
          }
          if (item?.types?.includes("locality")) {
            obj = Object.assign(obj, { city: item.long_name });
          }
          if (item?.types?.includes("postal_code")) {
            obj = Object.assign(obj, { zip_code: item.short_name });
          }
        });

        // Set the address in service_address object
        this.setState(
          {
            service_address:
              obj?.street_number || obj?.route
                ? {
                  ...obj,
                  address: `${obj?.street_number || ""} ${obj?.route || ""}`,
                }
                : obj,
          },
          () => {
            this.storeInLocal();
            this.getPriceMatrics();
          }
        );

        if (is_billing_address_same) {
          this.setState({
            billing_address:
              obj?.street_number && obj?.route
                ? {
                  ...obj,
                  address: `${obj?.street_number} ${obj?.route}`,
                }
                : obj,
          });
        }
      } else {
        message.error("Something went wrong while getting address");
      }
    }
  };

  creditcardclicked = () => {
    this.setState({ displayCard: true });
    this.setState({ displayBank: false });
  };

  bankaccountclicked = () => {
    this.setState({ displayBank: true });
    this.setState({ displayCard: false });
  };

  onCreditCardInfoChange = (e) => {
    const { credit_card_info } = this.state;
    Object.assign(credit_card_info, {
      [Object.keys(e)[0]]: e[Object.keys(e)[0]],
    });
    this.setState({ credit_card_info });
  };

  onBankCardInfoChange = (e) => {
    const { bank_account_info } = this.state;

    Object.assign(bank_account_info, {
      [Object.keys(e)[0]]: e[Object.keys(e)[0]],
    });

    this.setState({ bank_account_info });
  };

  onChangeCheckbox = (checked) => {
    this.setState({ checked_permissions: checked });
    this.setState({ is_authorize_charge_each_month: checked });
  };

  onChangeBankDetailsCheckbox = (checked) => {
    this.setState({ checked_permissions_ach: checked });
    this.setState({ is_authorize_charge_each_month: checked });
  };

  setFattJs = (param) => {
    this.fattJs = param;
  };

  removeEmpty = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v !== null && v?.trim() !== "")
    );
  };

  //Call API Based on selection
  getPriceMatrics = () => {
    setTimeout(() => {
      let pets = 0;
      let step1 = JSON.parse(sessionStorage.getItem("step1"));
      const zipcode = JSON.parse(sessionStorage.getItem("area"));

      const {
        is_extra_pet,
        field_office_uuid,
        frequency,
        pet_count,
        extra_pet_count,
        last_cleaned,
        property_type,
        prepay_for_year,
        areas_to_clean,
        add_ons,
        coupon_code,
      } = step1 || {};

      // for pet count
      if (pet_count === "" && is_extra_pet && extra_pet_count) {
        pets = extra_pet_count;
      } else {
        pets = pet_count;
      }

      if (pets && property_type && frequency) {
        let api_data = {
          is_prepaid: this.props.is_prepaid,
          field_office_uuid: field_office_uuid,
          frequency: frequency,
          pet_count: pets,
          last_cleaned: last_cleaned || null,
          property_type: property_type,
          prepay_for_year: prepay_for_year,
          areas_to_clean: areas_to_clean,
          add_ons: add_ons,
          prepay_months: this.props.prepay_months,
          coupon_code: coupon_code,
          zipcode: zipcode?.zipcode,
          address: this.state.service_address,
        };

        this.props.pricingCalculator(api_data);
      }
    }, 400);
  };

  // Render Date List
  renderDateList = () => {
    const { preferred_start_date, preferred_days } = this.state;
    return map(preferred_days.sort()?.slice(0, 3), (item, i) => {
      return (
        <label
          key={i}
          htmlFor={item}
          className={
            preferred_start_date === null
              ? "area_box"
              : preferred_start_date === item
                ? "area_box active_area_box"
                : "area_box box_opacity"
          }
        >
          <span>{moment(item, "MM-DD-YYYY").format("ddd, MMM DD")}</span>
          <input
            type="checkbox"
            checked={preferred_start_date === item ? true : false}
            name="preferred_start_date"
            id={item}
            value={item}
            onChange={(e) => {
              this.onDataChange(e, "preferred_start_date");
            }}
            className="custom--checkbox"
          />
        </label>
      );
    });
  };

  //renderExtraFooter
  renderExtraFooter = () => {
    return (
      <div className="data_indicator">
        <a
          href="/#"
          onClick={(e) => {
            e.preventDefault();
          }}
          className="btn"
        >
          Available
        </a>
        <a
          href="/#"
          onClick={(e) => {
            e.preventDefault();
          }}
          className="btn unavailable"
        >
          Unavailable
        </a>
      </div>
    );
  };

  //renderAllState
  renderAllState = () => {
    return map(AllState, (item, i) => {
      return (
        <Option value={item.abbreviation} key={i}>
          {item.abbreviation}
        </Option>
      );
    });
  };

  // Single Value Select
  onDataChange = (e, name) => {
    if (e.target.checked) {
      this.setState({
        [name]: e.target.value,
        display_preferred_start_date: null,
      });
      // Check mandatory field
      // delete this.state.errors.preferred_start_date
    } else {
      this.setState({
        [name]: null,
        display_preferred_start_date: null,
      });
    }
    // this.Step2Validation();
  };

  //Multi Value Select
  onContactChange = (e) => {
    const { preferred_contact_methods } = this.state;
    const value = e.target.value;
    if (e.target.checked) {
      preferred_contact_methods.push(value);
      this.setState({
        preferred_contact_methods,
      });
    } else {
      const index = preferred_contact_methods.indexOf(value);
      if (index > -1) {
        preferred_contact_methods.splice(index, 1);
      }

      this.setState({
        preferred_contact_methods,
      });
    }
    // Check mandatory field
    // this.Step2Validation();
    if (preferred_contact_methods.length > 0) {
      // delete this.state.errors.preferred_contact_methods;
    }
  };

  //Address change
  addressChange = (e, name) => {
    const { service_address, is_billing_address_same, billing_address } =
      this.state;
    let newServiceAddress = { ...service_address };
    let newBillingAddress = { ...billing_address };
    if (name === "service_address") {
      newServiceAddress = Object.assign(newServiceAddress, {
        [e.target.name]: e.target.value,
      });
      this.setState(
        {
          service_address:
            newServiceAddress?.street_number && newServiceAddress?.route
              ? {
                ...newServiceAddress,
                address: `${newServiceAddress?.street_number} ${newServiceAddress?.route}`,
              }
              : newServiceAddress,
        },
        () => {
          const { service_address } = this.state;
          this.storeInLocal();
          if (Object.values(service_address)?.every((x) => x !== ""))
            this.getPriceMatrics();
        }
      );
      if (is_billing_address_same) {
        this.setState({
          billing_address:
            newServiceAddress?.street_number && newServiceAddress?.route
              ? {
                ...newServiceAddress,
                address: `${newServiceAddress?.street_number} ${newServiceAddress?.route}`,
              }
              : newServiceAddress,
        });
      }
    }
    if (name === "billing_address") {
      newBillingAddress = Object.assign(newBillingAddress, {
        [e.target.name]: e.target.value,
      });
      this.setState({
        billing_address:
          newBillingAddress?.street_number && newBillingAddress?.route
            ? {
              ...newBillingAddress,
              address: `${newBillingAddress?.street_number} ${newBillingAddress?.route}`,
            }
            : newBillingAddress,
      });
    }
  };

  //Billing Information save
  billingOnChange = (e) => {
    let { is_login_user } = this.state;
    if (!is_login_user) {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  //Add More Concatc
  addMoreContact = (e) => {
    e.preventDefault();
    const { multiple_concact } = this.state;
    const id = multiple_concact.length + 1;
    multiple_concact.push({ uuid: id, phone: "", type: "", can_send_sms: "" });

    this.setState({
      multiple_concact,
    });
  };

  //removeMultiContact
  removeMultiContact = (e, id) => {
    e.preventDefault();
    const { multiple_concact } = this.state;
    var index = multiple_concact.indexOf(id);
    multiple_concact.splice(index, 1);
    this.setState({
      multiple_concact,
    });
  };

  //multipleContactOnChange
  multipleContactOnChange = (e, type, id) => {
    const multiple_concact = [...this.state.multiple_concact];
    const name = e.target.name.split("-")[0];

    if (type === "text") {
      multiple_concact[id][name] = e.target.value;
    }

    if (type === "can_send_sms") {
      if (e.target.checked) {
        multiple_concact[id][name] = e.target.checked;
      } else {
        multiple_concact[id][name] = e.target.checked;
      }
    }

    this.setState({
      multiple_concact,
    });
  };

  //render Multiple Contact
  renderMultipleContact = () => {
    const { multiple_concact } = this.state;
    return map(multiple_concact, (item, i) => {
      return (
        <React.Fragment key={i}>
          <div className="billing_control phone_control">
            <div className="multi_control mr-2">
              <input
                type="text"
                inputMode="numeric"
                max="10"
                maxLength="10"
                onPaste={(event) => {
                  if (event.clipboardData.getData("Text").match(/[^\d]/)) {
                    event.preventDefault();
                  }
                }}
                onKeyPress={(e) => {
                  const pattern = /[0-9]/;
                  const inputChar = String.fromCharCode(e.charCode);
                  if (!pattern.test(inputChar)) {
                    // invalid character, prevent input
                    e.preventDefault();
                  }
                }}
                className="form--control mr-2"
                placeholder="Secondary Number"
                name={"phone-" + i}
                value={
                  multiple_concact[i]["phone"] === 0
                    ? ""
                    : multiple_concact[i]["phone"]
                }
                onChange={(e) => {
                  this.multipleContactOnChange(e, "text", i);
                }}
              />
            </div>
            <div className="multi_control mr-2 phone_number_type">
              <Select
                placeholder="Type"
                suffixIcon={<img src={chevron} alt="" />}
                name={"type-" + i}
                onChange={(e) => {
                  multiple_concact[i]["type"] = e;
                  multiple_concact[i]["can_send_sms"] = false;
                  this.setState({
                    multiple_concact,
                  });
                }}
                value={multiple_concact[i].type || undefined}
              >
                <Option value="home_phone">Home</Option>
                <Option value="mobile">Mobile</Option>
              </Select>
            </div>
            <div className="remove_more_contact multi_control">
              <a
                href="/#"
                onClick={(e) => {
                  this.removeMultiContact(e, item);
                }}
              >
                <img src={cross_icon} alt="" className="remove_contact" />
              </a>
            </div>
          </div>
          {multiple_concact[i].type === "mobile" ? (
            <div className="billing_control">
              <div className="checkbox_wrapper">
                <input
                  id={i}
                  checked={multiple_concact[i]["can_send_sms"]}
                  name={"can_send_sms" + i}
                  type="checkbox"
                  onChange={(e) => {
                    multiple_concact[i]["can_send_sms"] = e.target.checked;
                    this.setState({ multiple_concact });
                  }}
                />
                <label htmlFor={i}>
                  Send SMS updates about my service to this number. (Additional
                  carrier rates may apply)
                </label>
              </div>
            </div>
          ) : (
            ""
          )}
        </React.Fragment>
      );
    });
  };

  //Single  Contact On Change
  singleContactOnChange = (e, type) => {
    const { single_contact } = this.state;
    let newSingleContact = { ...single_contact };
    if (type === "text") {
      newSingleContact = Object.assign(newSingleContact, {
        [e.target.name]: e.target.value,
      });
    }

    if (type === "contact_type") {
      // Check mandatory field

      newSingleContact = Object.assign(newSingleContact, {
        type: e,
        can_send_sms: false,
      });
    }
    if (type === "can_send_sms") {
      if (e.target.checked) {
        newSingleContact = Object.assign(newSingleContact, {
          can_send_sms: e.target.checked,
        });
      } else {
        newSingleContact = Object.assign(newSingleContact, {
          can_send_sms: e.target.checked,
        });
      }
    }

    this.setState({ single_contact: newSingleContact });
  };

  //changeState
  changeState(value, name) {
    const { service_address, is_billing_address_same, billing_address } =
      this.state;

    if (name === "service_address") {
      const newServiceAddress = { ...service_address };
      newServiceAddress.state = value;
      this.setState({ service_address: newServiceAddress }, () =>
        this.getPriceMatrics()
      );
      if (is_billing_address_same) {
        this.setState({ billing_address: newServiceAddress });
      }
    }
    if (name === "billing_address") {
      const newBillingAddress = { ...billing_address };
      newBillingAddress.state = value;
      this.setState({ billing_address: newBillingAddress });
    }
  }

  isLoggedIn = () => {
    // get userKey from local storage and check if it is not empty
    try {
      const userKey = localStorage.getItem("userKey");
      if (!isEmpty(JSON.parse(userKey))) {
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  // Set payment method on stax
  SetPaymentMethod = async () => {
    const self = this;

  const {
    errors,
    billing_address,
    first_name,
    last_name,
    email,
    single_contact,
    card_number,
    is_overwrite,
    hear_about_us,
    credit_card_info,
    bank_account_info,
  } = self.state;

  return new Promise ((resolve) => {
    const token_obj = this.state.displayBank
      ? {
        address_1: billing_address.address,
        address_city: billing_address.city,
        address_state: billing_address.state,
        address_zip: billing_address.zip_code,
        bank_account: bank_account_info?.ach_account_number,
        bank_routing: bank_account_info?.ach_routing_number,
        bank_holder_type: bank_account_info?.ach_bank_holder_type || "",
        bank_type: bank_account_info?.ach_account_type || "",
        email: email,
        firstname: first_name,
        lastname: last_name,
        method: "bank",
        person_name: first_name + " " + last_name,
        phone: single_contact.phone,
      }
      : {
        address_1: billing_address.address,
        address_city: billing_address.city,
        address_state: billing_address.state,
        address_zip: billing_address.zip_code,
        month: credit_card_info?.card_expiry_month,
        year: credit_card_info?.card_expiry_year,
        card_number: card_number,
        email: email,
        firstname: first_name,
        lastname: last_name,
        method: "card",
        person_name: first_name + " " + last_name,
        phone: single_contact.phone,
      };
  
    if (Object.keys(this.props.AccountInfo.data).length) {
      token_obj["customer_id"] =
        this.props.AccountInfo.data.stax_customer || null;
    } else {
      sessionStorage.setItem("newUserEmail", email);
    }
  
    self.setState({ loader: true });
  
    this.fattJs
      .tokenize(token_obj)
      .then((res) => {
        if (res && Object.keys(res).length > 0) {
          self.setState({
            loader: false,
            stax_card_token: res["id"] || null,
          });
          resolve(true);
        }
      })
      .catch((error) => {
        console.error("Errors", error);
  
        let mapped_errors = [];

        if(Object.keys(error).length > 0)
        {
          Object.keys(error).forEach((key) => {
            mapped_errors.push(error[key][0]);
          });
        }
        else
        {
          mapped_errors = error?.errors?.map(item => item);
        }
        
        mapped_errors.forEach(element => {
          message.error(element)
        });

        self.setState({ errors: {...errors, payment: error}, loader: false });
        resolve(false);
      });
    })
  };

  // Place Order on API
  PlaceServiceOrder = async () => {
    const {
      is_authorize_charge_each_month,
      is_ternm_accepted,
      is_overwrite,
      hear_about_us,
      stax_card_token,
    } = this.state;

    const payload = JSON.parse(sessionStorage.getItem("step2"));
    let temp_hear_about_us = sessionStorage.getItem("hear_about_us");

    if (is_overwrite) {
      temp_hear_about_us = hear_about_us;
    }

    if(stax_card_token && stax_card_token !== "")
    {
      const payloadWithPrepayInfo = {
        ...payload,
        is_prepaid: this.props.is_prepaid,
        prepay_months: this.props.prepay_months,
        is_authorize_charge_each_month,
        is_ternm_accepted,
        stax_card_token,
        hear_about_us: temp_hear_about_us
          ? Array.isArray(temp_hear_about_us)
            ? temp_hear_about_us
            : [temp_hear_about_us]
          : [],
        ...(this.isLoggedIn() ? {} : { is_enquiry: true }),
      };
  
  
      return new Promise ((resolve, reject) => {
        if (this.isLoggedIn()) {
          this.props.placeOrder(payloadWithPrepayInfo)
          .then((res) => {
            resolve();
          })
          .catch((errors) => {
            reject();
          });
        } else {
          this.props.placeOrderInquery(payloadWithPrepayInfo)
          .then((res) => {
            resolve();
          })
          .catch((errors) => {
            reject();
          });
        }
      });
    }
  };

  // Validation
  Step2Validation = (mobile_check) => {
    let self = this;
    let area = JSON.parse(sessionStorage.getItem("area"));

    setTimeout(() => {
      const { service_address, is_address_manually } = self.state;
      if (is_address_manually) {
        this.Step2Setup(mobile_check);
      } else {
        axios
          .post(`${config.getHost()}service-order/validate_address/`, {
            field_office_uuid: area && area.uuid,
            address: `${service_address?.address},${service_address?.city},${service_address?.state},${service_address?.zip_code}`,
          })
          .then((response) => {
            if (Object.keys(response).length > 0 && response?.data?.is_valid) {
              this.Step2Setup(mobile_check);
            } else {
              self.setState({ loader: false });
              message.error(
                "Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates."
              );
            }
          })
          .catch(() => {
            message.error(
              "Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates."
            );
          });
      }
    }, 300);
  };

  Step2Setup = async (mobile_check) => {
    let self = this;
    let is_payment_info_valid = false;
    let step1 = JSON.parse(sessionStorage.getItem("step1"));
    let area = JSON.parse(sessionStorage.getItem("area"));

    const newFunc = async (mobile_check) => {
      const {
        errors,
        hear_about_us,
        is_ternm_accepted,
        service_address,
        is_address_manually,
        preferred_start_date,
        billing_address,
        is_billing_address_same,
        first_name,
        last_name,
        email,
        preferred_contact_methods,
        single_contact,
        multiple_concact,
        service_add_ons = [],
        is_authorize_charge_each_month,
        registered_email,
        credit_card_info,
        bank_account_info,
      } = self.state;

      if(service_address?.geo_location?.longitude === null) {
        service_address.geo_location = null;
      }

      if(billing_address?.geo_location?.longitude === null) {
        billing_address.geo_location = null;
      }

      const Step2Schema = this.state.displayBank
        ? yup.object().shape({
          service_address: yup.object().shape({
            address: yup.string().required("Address is required"),
            state: yup.string().required("State is required"),
            city: yup.string().required("City is required"),
            zip_code: yup
              .string()
              .required("Zipcode is required")
              .min(5, "Your ZIP code is invalid.")
              .max(5, "Your ZIP code is invalid."),
          }),
          preferred_start_date: yup
            .string()
            .required("Preferred start date is required")
            .nullable(),
          first_name: yup.string().required("First name is required"),
          last_name: yup.string().required("Last name is required"),
          email: yup
            .string()
            .required("Email is required")
            .email("Your Email is invalid."),
          preferred_contact_methods: yup
            .array()
            .required("Preferred contact methods is required"),
          bank_account_info: yup.object().shape({
            ach_bank_account_name: yup
              .string()
              .required("Please enter correct value !"),
            ach_routing_number: yup
              .string()
              .required("Please enter correct value !")
              .min(9, "Total number of digits should be 9")
              .max(9, "Total number of digits should be 9"),
            ach_account_number: yup
              .string()
              .nullable()
              .required("Please enter correct value !")
              .max(15, "Length should not greater than 15"),
            ach_account_type: yup
              .string()
              .required("Please enter correct value !"),
            ach_bank_holder_type: yup
              .string()
              .required("Please enter correct value !"),
          }),
          single_contact: yup.object().shape({
            phone: yup
              .string()
              .required("Phone is required")
              .min(10, "Number is not valid"),
            type: yup.string().required("Type is required"),
          }),

          billing_address: yup.object().when("is_billing_address_same", {
            is: false,
            then: yup.object().shape({
              address: yup.string().required("Address is required"),
              state: yup.string().required("State is required"),
              city: yup.string().required("City is required"),
              zip_code: yup
                .string()
                .required("Zipcode is required")
                .min(5, "Your ZIP code is invalid."),
            }),
          }),
          is_ternm_accepted: yup
            .bool()
            .oneOf([true], "Please acknowledge the terms and conditions"),
        })
        : yup.object().shape({
          service_address: yup.object().shape({
            address: yup.string().required("Address is required"),
            state: yup.string().required("State is required"),
            city: yup.string().required("City is required"),
            zip_code: yup
              .string()
              .required("Zipcode is required")
              .min(5, "Your ZIP code is invalid.")
              .max(5, "Your ZIP code is invalid."),
          }),
          preferred_start_date: yup
            .string()
            .required("Preferred start date is required")
            .nullable(),
          first_name: yup.string().required("First name is required"),
          last_name: yup.string().required("Last name is required"),
          email: yup
            .string()
            .required("Email is required")
            .email("Your Email is invalid."),
          preferred_contact_methods: yup
            .array()
            .required("Preferred contact methods is required"),
          credit_card_info: yup.object().shape({
            card_number: this.fattJs.validNumber
              ? null
              : yup.string().nullable().required("Card Number is required"),
            card_expiry_month: yup
              .string()
              .nullable()
              .required("Expire Month is required"),
            card_expiry_year: yup
              .string()
              .nullable()
              .required("Expire Year is required")
              .min(4, "Card expire year is invalid.")
              .max(4, "Card expire year is invalid."),
            card_cvv: this.fattJs.validCvv
              ? null
              : yup.string().nullable().required("CVV is required"),
          }),
          single_contact: yup.object().shape({
            phone: yup
              .string()
              .required("Phone is required")
              .min(10, "Number is not valid"),
            type: yup.string().required("Type is required"),
          }),

          billing_address: yup.object().when("is_billing_address_same", {
            is: false,
            then: yup.object().shape({
              address: yup.string().required("Address is required"),
              state: yup.string().required("State is required"),
              city: yup.string().required("City is required"),
              zip_code: yup
                .string()
                .required("Zipcode is required")
                .min(5, "Your ZIP code is invalid."),
            }),
          }),
          is_ternm_accepted: yup
            .bool()
            .oneOf([true], "Please acknowledge the terms and conditions"),
        });

      const Step2Data = {
        service_address,
        billing_address,
        is_address_manually,
        preferred_start_date,
        is_billing_address_same,
        first_name,
        last_name,
        email,
        preferred_contact_methods,
        single_contact,
        multiple_concact,
        is_ternm_accepted,
        is_authorize_charge_each_month,
        credit_card_info,
        bank_account_info,
        field_office: area && area.uuid,
      };

      let err_data = {};
      is_payment_info_valid = await this.SetPaymentMethod();

      (async () => {
        try {
          const isValid = await Step2Schema.isValid(Step2Data);
      
          if (isValid) {
            self.setState({
              is_checkout_btn_active: true,
              is_checkout_mobile_btn_active: mobile_check,
            }, () => {
              if (this.state.is_checkout_mobile_btn_active) {
                this.props.checOutSidebar();
              }
            });
         }

          innerFunc(isValid, mobile_check);
            console.log('isValid:', isValid);
          } catch (error) {
            console.error('Error:', error);
          }
        }
      )();

      const innerFunc = async (isValid) => {
      if (isValid && mobile_check === false) {

        const lead_uuid = JSON.parse(sessionStorage.getItem("lead"));
        const phone_numbers = multiple_concact.concat(single_contact);

        map(phone_numbers, (item) => {
          if (!item.uuid) delete item.uuid;
        });

        const params = {
          zip_code: area.zipcode,
          field_office_uuid: area.uuid,
          first_name: first_name,
          hear_about_us: hear_about_us,
          last_name: last_name,
          address: [billing_address],
          emailaddress_set: [
            {
              email: registered_email,
              primary: true,
            },
          ],
          authorizedUser_list: [],
          leadStage: "new",
          outreach: "website",
          phone_numbers: phone_numbers,
          role: ["customer"],
          is_dummy_email: false,
          is_crm: false,
        };

        if(!is_payment_info_valid)
        {
          return;
        }

        // Get data from add_on and create response as per api and pass in service_add_ons
        map(step1.add_ons, (item) => {
          service_add_ons.push({
            add_on_uuid: item.uuid,
            add_on_name: item.name,
            is_recurring: item.is_recurring,
          });
        });

        const data = {
          field_office_uuid: area && area.uuid,
          service_type: "residential",
          property_type: step1.property_type && step1.property_type,
          frequency: step1.frequency && step1.frequency,
          service_add_ons: service_add_ons,
          pet_count: step1.pet_count && step1.pet_count,
          pets: [],
          area_to_clean: step1.areas_to_clean && step1.areas_to_clean,
          last_cleaned: step1.last_cleaned && step1.last_cleaned,
          service_address: service_address,
          billing_address: is_billing_address_same
            ? service_address
            : billing_address
              ? billing_address
              : service_address,
          preferred_start_date: moment(
            preferred_start_date,
            "MM-DD-YYYY"
          ).format("YYYY-MM-DD"),
          is_billing_address_same: is_billing_address_same,
          first_name: first_name,
          last_name: last_name,
          email: email,
          phone_numbers: phone_numbers,
          preferred_contact_methods: preferred_contact_methods,
          cleaning_notes: step1.cleaning_notes || "",
          disposal_location: step1.disposal_location || "",
          prepay_months: this.props.prepay_months,
          is_prepaid: this.props.is_prepaid,
          coupon_code: step1.coupon_code || "",
          service_zipcode: area && area.zipcode ? area.zipcode : "",
        };

        sessionStorage.setItem("step2", JSON.stringify(data));

        await self.PlaceServiceOrder();

        this.props.updateLead(lead_uuid, params);
        this.props.updateCustomerLastCompletedStep({
          step: 4,
          tracking_uuid: JSON.parse(sessionStorage.getItem("tracking_uuid"))
        });
      } else {
        Step2Schema.validate(Step2Data, { abortEarly: false }).catch(
          function (err) {
            map(err.inner, (item) => {
              err_data[item.path] = item.message;
            });

            self.setState({
              errors: {...errors, err_data},
              is_checkout_btn_active: false,
              loader: false,
            });

            console.log(errors);
            console.log("err_data:", err_data);
          }
        );}
      };
    };

    newFunc(mobile_check);
  };

  setLoader = (load) => {
    this.setState({
      loader: load,
    });
  };

  updateAddress = (address) => {
    const { is_billing_address_same } = this.state;
    this.setState({ service_address: address });
    if (is_billing_address_same) {
      this.setState({ billing_address: address });
    }
  };

  render() {
    const {
      service_address,
      billing_address,
      preferred_contact_methods,
      is_address_manually,
      is_billing_address_same,
      single_contact,
      display_preferred_start_date,
      preferred_start_date,
      first_name,
      email,
      last_name,
      is_ternm_accepted,
      loader,
      is_checkout_btn_active,
      is_mobile,
      is_login_user,
      multiple_concact,
      errors,
      preferred_days,
      is_order_placed,
      registered_email,
      is_checkout_mobile_btn_active
    } = this.state;

    let phone_arr = [...multiple_concact, single_contact],
      is_mobile_phone = false,
      is_home_phone = false;
    if (!isEmpty(phone_arr)) {
      is_mobile_phone =
        phone_arr?.filter((x) => x.type === "mobile")?.length > 0;
      is_home_phone =
        phone_arr?.filter((x) => x.type === "home_phone")?.length > 0;
    }

    return (
      <div className="row">
        <div className={this.props.is_final_sidebar ? "d-none" : "col-md-7"}>
          <div className="step3">
            <label
              className="back_arrow cursor_pointer"
              onClick={() => {
                this.props.next(0);
              }}
            >
              <i className="las la-arrow-left"></i>Back{" "}
            </label>
            <section className="service_address">
              <h1>
                Service Address<span className="required">*</span>
              </h1>
              <AddressEntry
                id="service_address"
                address={service_address}
                onUpdateAddress={this.updateAddress}
              />
              {errors["service_address.address"] ||
              errors["service_address.city"] ||
              errors["service_address.state"] ||
              errors["service_address.zip_code"] ? (
                  <label className="new_err_msg">
                    <i className="las la-info-circle" />
                    {"Please enter valid address"}
                  </label>
                ) : (
                  ""
                )}
            </section>
            <section className="preferred_date">
              <h2>
                Preferred start date <span className="required">*</span>
                <span>(select one)</span>
              </h2>

              <div className="date_list_wrapper">
                {this.renderDateList()}
                <DatePicker
                  renderExtraFooter={() => this.renderExtraFooter()}
                  inputReadOnly
                  mode={"date"}
                  className={
                    preferred_start_date === null
                      ? "preferred_date_picker"
                      : display_preferred_start_date
                        ? "preferred_date_picker selected_date"
                        : "preferred_date_picker box_opacity"
                  }
                  placeholder={
                    is_mobile ? "Choose Date" : "Select another date"
                  }
                  format={"ddd, MMM DD"}
                  value={display_preferred_start_date}
                  onChange={(e) => {
                    this.setState({
                      display_preferred_start_date: e,
                      preferred_start_date: moment(e).format("MM-DD-YYYY"),
                    });
                  }}
                  disabledDate={(current) => {
                    return !preferred_days
                      ?.sort()
                      ?.slice(3, preferred_days.length)
                      .includes(moment(current).format("MM-DD-YYYY"));
                  }}
                />
                {errors && errors["preferred_start_date"] ? (
                  <label className="new_err_msg">
                    <i className="las la-info-circle"></i>{" "}
                    {errors["preferred_start_date"]}
                  </label>
                ) : (
                  ""
                )}
              </div>
            </section>
            <section className="billing_section">
              <h2>
                Contact Information <span className="required">*</span>
              </h2>
              <div className="billing_form">
                <div className="billing_control">
                  <div className="multi_control mr-2">
                    <input
                      type="text"
                      value={first_name}
                      onChange={(e) => {
                        this.billingOnChange(e);
                      }}
                      disabled={is_login_user}
                      className={
                        is_login_user
                          ? "disble_login_control form--control mr-2"
                          : "form--control mr-2"
                      }
                      placeholder="First Name"
                      name="first_name"
                    />
                    {errors && errors["first_name"] ? (
                      <label className="new_err_msg">
                        <i className="las la-info-circle"></i>{" "}
                        {errors["first_name"]}
                      </label>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="multi_control">
                    <input
                      type="text"
                      value={last_name}
                      onChange={(e) => {
                        this.billingOnChange(e);
                      }}
                      className={
                        is_login_user
                          ? "disble_login_control form--control mr-2"
                          : "form--control mr-2"
                      }
                      placeholder="Last Name"
                      name="last_name"
                    />
                    {errors && errors["last_name"] ? (
                      <label className="new_err_msg">
                        <i className="las la-info-circle"></i>{" "}
                        {errors["last_name"]}
                      </label>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="billing_control">
                  <div className="single_control">
                    <input
                      type="text"
                      value={registered_email ? registered_email : email}
                      disabled={is_login_user || registered_email}
                      onChange={(e) => this.billingOnChange(e)}
                      className={
                        is_login_user || registered_email
                          ? "disble_login_control form--control mr-2"
                          : "form--control mr-2"
                      }
                      placeholder="Email Address"
                      name="email"
                    />
                    {errors && errors["email"] ? (
                      <label className="new_err_msg">
                        <i className="las la-info-circle"></i> {errors["email"]}
                      </label>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="billing_control phone_control">
                  <div className="multi_control mr-2">
                    <input
                      type="text"
                      inputMode="numeric"
                      className={
                        is_login_user
                          ? "disble_login_control form--control mr-2"
                          : "form--control mr-2"
                      }
                      placeholder="Primary Number"
                      disabled={is_login_user}
                      value={single_contact.phone || ""}
                      max="10"
                      maxLength="10"
                      onPaste={(event) => {
                        if (
                          event.clipboardData.getData("Text").match(/[^\d]/)
                        ) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      name="phone"
                      onChange={(e) => {
                        this.singleContactOnChange(e, "text");
                      }}
                    />
                    {errors && errors["single_contact.phone"] ? (
                      <label className="new_err_msg">
                        <i className="las la-info-circle"></i>{" "}
                        {errors["single_contact.phone"]}
                      </label>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="multi_control mr-2 phone_number_type">
                    <Select
                      onChange={(e) => {
                        this.singleContactOnChange(e, "contact_type");
                      }}
                      name="type"
                      disabled={is_login_user}
                      suffixIcon={<img src={chevron} alt="" />}
                      value={single_contact.type}
                      className={is_login_user ? "disble_login_select" : ""}
                      placeholder="Type"
                    >
                      <Option value="home_phone">Home</Option>
                      <Option value="mobile">Mobile</Option>
                    </Select>
                    {errors && errors["single_contact.type"] ? (
                      <label className="new_err_msg">
                        <i className="las la-info-circle"></i>{" "}
                        {errors["single_contact.type"]}
                      </label>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="multi_control add_more_contact">
                    <a
                      href="/#"
                      onClick={(e) => {
                        this.addMoreContact(e);
                      }}
                    >
                      <img src={plus_icon} alt="" />
                    </a>
                  </div>
                </div>
                <div className="billing_form">
                  {this.renderMultipleContact()}
                </div>
                {single_contact.type === "mobile" && (
                  <div className="billing_control">
                    <div className="checkbox_wrapper">
                      <input
                        id="can_send_sms"
                        name="can_send_sms"
                        checked={single_contact.can_send_sms}
                        type="checkbox"
                        onChange={(e) => {
                          this.singleContactOnChange(e, "can_send_sms");
                        }}
                      />
                      <label htmlFor="can_send_sms">
                        Send SMS updates about my service to this number.
                        (Additional carrier rates may apply)
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </section>
            <section className="preferred_contact">
              <h2>
                Preferred contact method <span className="required">*</span>
                <span>(select multiple)</span>
              </h2>

              <div className="contact_method_wrapper">
                {is_mobile_phone ? (
                  <label
                    htmlFor="text"
                    className={
                      preferred_contact_methods.includes("text")
                        ? "area_box active_area_box"
                        : preferred_contact_methods.length > 0 &&
                          preferred_contact_methods.includes("text")
                          ? "area_box "
                          : "area_box"
                    }
                  >
                    <span>Text</span>
                    <input
                      type="checkbox"
                      checked={
                        preferred_contact_methods.includes("text")
                          ? true
                          : false
                      }
                      id="text"
                      value="text"
                      onChange={(e) => {
                        this.onContactChange(e);
                      }}
                      name="text"
                      className="custom--checkbox"
                    />
                  </label>
                ) : (
                  ""
                )}
                {is_home_phone ? (
                  <label
                    htmlFor="home_phone"
                    className={
                      preferred_contact_methods.includes("home_phone")
                        ? "area_box active_area_box"
                        : preferred_contact_methods.length > 0 &&
                          preferred_contact_methods.includes("home_phone")
                          ? "area_box "
                          : "area_box"
                    }
                  >
                    <span>Home Phone</span>
                    <input
                      type="checkbox"
                      checked={
                        preferred_contact_methods.includes("home_phone")
                          ? true
                          : false
                      }
                      id="home_phone"
                      value="home_phone"
                      onChange={(e) => {
                        this.onContactChange(e);
                      }}
                      name="home_phone"
                      className="custom--checkbox"
                    />
                  </label>
                ) : (
                  ""
                )}
                {is_mobile_phone ? (
                  <label
                    htmlFor="mobile"
                    className={
                      preferred_contact_methods.includes("mobile")
                        ? "area_box active_area_box"
                        : preferred_contact_methods.length > 0 &&
                          preferred_contact_methods.includes("mobile")
                          ? "area_box "
                          : "area_box"
                    }
                  >
                    <span>Mobile</span>
                    <input
                      type="checkbox"
                      checked={
                        preferred_contact_methods.includes("mobile")
                          ? true
                          : false
                      }
                      id="mobile"
                      value="mobile"
                      onChange={(e) => {
                        this.onContactChange(e);
                      }}
                      name="mobile"
                      className="custom--checkbox"
                    />
                  </label>
                ) : (
                  ""
                )}
                <label
                  htmlFor="emails"
                  className={
                    preferred_contact_methods.includes("email")
                      ? "area_box active_area_box"
                      : preferred_contact_methods.length > 0 &&
                        preferred_contact_methods.includes("email")
                        ? "area_box "
                        : "area_box"
                  }
                >
                  <span>Email</span>
                  <input
                    type="checkbox"
                    checked={
                      preferred_contact_methods.includes("email") ? true : false
                    }
                    id="emails"
                    value="email"
                    onChange={(e) => {
                      this.onContactChange(e);
                    }}
                    name="email"
                    className="custom--checkbox"
                  />
                </label>
                {errors && errors["preferred_contact_methods"] ? (
                  <label className="new_err_msg">
                    <i className="las la-info-circle"></i>{" "}
                    {errors["preferred_contact_methods"]}
                  </label>
                ) : (
                  ""
                )}
              </div>
            </section>
            <div className="border_bottom_end"></div>
            <section className="payment_information">
              <h2>
                Payment Information <span className="required">*</span>
              </h2>
              <p className="sub_title mb-0 font-weight-700">
                Accounts are charged the beginning of each month for service
                provided the prior month.
              </p>

              <div
                className="payment-section"
                style={{
                  border: "1px solid #DCDCE6",
                  borderRadius: "8px",
                  padding: "8px 19px 18px 10px",
                  width: "100%",
                  marginBottom: "18px",
                }}
              >
                <div
                  onChange={this.bankaccountclicked}
                  className="half_size_items"
                  style={{
                    justifyContent: "space-between",
                    flexFlow: "row",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <div
                    className="radio-heading_bank_details"
                    style={{ marginBottom: "10px" }}
                  >
                    <input
                      type="radio"
                      value="3"
                      name="bank_details"
                      checked={this.state.displayBank}
                      style={{ marginRight: "15px" }}
                    />
                    <h4 className="mb-0" style={{ color: "#297c78" }}>
                      Bank Account
                    </h4>
                  </div>
                  <img
                    src={BankAccount}
                    alt={"No image Found"}
                    style={{ width: "200px", height: "20px", display: "flex" }}
                  ></img>
                </div>
                <hr style={{ margin: "0px", width: "100%" }} />
                {this.state.displayBank && (
                  <BankAccountDetails
                    onBankCardInfoChange={this.onBankCardInfoChange}
                    setFattJs={this.setFattJs}
                    onChangeBankDetailsCheckbox={
                      this.onChangeBankDetailsCheckbox
                    }
                    {...this.state}
                  ></BankAccountDetails>
                )}
              </div>

              <div
                className="payment-section"
                style={{
                  border: "1px solid #DCDCE6",
                  borderRadius: "8px",
                  padding: "8px 19px 18px 10px",
                  width: "100%",
                }}
              >
                <div
                  onChange={this.creditcardclicked}
                  className="half_size_items"
                  style={{
                    justifyContent: "space-between",
                    flexFlow: "row",
                    display: "flex",
                    width: "100%",
                    // backgroundColor: 'red',
                    margin: "10px 0 0 0 ",
                  }}
                >
                  <div className="radio-heading_credit_card_details">
                    <input
                      type="radio"
                      value="displayCard"
                      name="credit_card"
                      style={{ marginRight: "15px" }}
                      checked={this.state.displayCard}
                    />
                    <h4 className="mb-0" style={{ color: "#297c78" }}>
                      Credit Card
                    </h4>
                  </div>
                  <img
                    src={AcceptedCards}
                    alt={"No image found"}
                    style={{ width: "200px", display: "flex" }}
                  ></img>
                </div>
                <hr style={{ margin: "0px", width: "100%" }} />
                {this.state.displayCard && (
                  <CreditCard
                    setFattJs={this.setFattJs}
                    onCreditCardInfoChange={this.onCreditCardInfoChange}
                    onChangeCheckbox={this.onChangeCheckbox}
                    {...this.state}
                  />
                )}
              </div>

              <div
                className="payment_control mt-2 mb-2"
                style={{ marginLeft: "11px" }}
              >
                <div className="checkbox_wrapper">
                  <input
                    id="same_address"
                    type="checkbox"
                    checked={is_billing_address_same}
                    onChange={(e) => {
                      if (e.target.checked) {
                        this.setState({
                          is_billing_address_same: true,
                          billing_address: service_address,
                        });
                      } else {
                        this.setState({
                          is_billing_address_same: false,
                          billing_address: {},
                        });
                      }
                      // this.Step2Validation()
                    }}
                  />
                  <label htmlFor="same_address">
                    My billing information is the same as my service address
                  </label>
                </div>
              </div>
            </section>
            {!is_billing_address_same && (
              <section className="service_address">
                <h2 className="mt-4 mb-3 d-block">Billing Address</h2>
                <div className="manually_address">
                  <div className="billing_control">
                    <div className="single_control">
                      <input
                        type="text"
                        autoComplete="off"
                        placeholder="Address"
                        value={billing_address.address}
                        onChange={(e) => {
                          this.addressChange(e, "billing_address");
                        }}
                        className="form--control"
                        name="address"
                      />
                      {errors && errors["billing_address.address"] ? (
                        <label className="new_err_msg">
                          <i className="las la-info-circle"></i>{" "}
                          {errors["billing_address.address"]}
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="billing_control">
                    <div className="multi_control mr-2 mt-2">
                      <input
                        type="text"
                        placeholder="City"
                        autoComplete="off"
                        value={billing_address.city}
                        onChange={(e) => {
                          this.addressChange(e, "billing_address");
                        }}
                        className="form--control mr-2"
                        name="city"
                      />
                      {errors && errors["billing_address.city"] ? (
                        <label className="new_err_msg">
                          <i className="las la-info-circle"></i>{" "}
                          {errors["billing_address.city"]}
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="multi_control mr-2 mt-2">
                      <Select
                        name="state"
                        autocomplete="off"
                        value={billing_address.state}
                        onChange={(e) => {
                          this.changeState(e, "billing_address");
                        }}
                        suffixIcon={<img src={chevron} alt="" />}
                        showSearch
                        placeholder="State"
                      >
                        {this.renderAllState()}
                      </Select>
                      {errors && errors["billing_address.state"] ? (
                        <label className="new_err_msg">
                          <i className="las la-info-circle"></i>{" "}
                          {errors["billing_address.state"]}
                        </label>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="multi_control mr-2 mt-2">
                      <input
                        type="text"
                        placeholder="Zipcode"
                        autoComplete="off"
                        value={billing_address.zip_code}
                        max="5"
                        maxLength="5"
                        onPaste={(event) => {
                          if (
                            event.clipboardData.getData("Text").match(/[^\d]/)
                          ) {
                            event.preventDefault();
                          }
                        }}
                        onKeyPress={(e) => {
                          const pattern = /[0-9]/;
                          const inputChar = String.fromCharCode(e.charCode);
                          if (!pattern.test(inputChar)) {
                            // invalid character, prevent input
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          this.addressChange(e, "billing_address");
                        }}
                        className="form--control"
                        name="zip_code"
                      />
                      {errors && errors["billing_address.zip_code"] ? (
                        <label className="new_err_msg">
                          <i className="las la-info-circle"></i>{" "}
                          {errors["billing_address.zip_code"]}
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="checkbox_wrapper mb-3 mt-20">
                    <input id="save_address_feature2" type="checkbox" />
                    <label htmlFor="save_address_feature2">
                      Save this billing address for future reference
                    </label>
                  </div>
                </div>
              </section>
            )}
            <div className="border_bottom_end"></div>
            <section className="tearm_service">
              <h2>
                Terms of Service <span className="required">*</span>
              </h2>
              <div className="checkbox_wrapper">
                <input
                  id="term"
                  checked={is_ternm_accepted}
                  type="checkbox"
                  onChange={(e) => {
                    this.setState({
                      is_ternm_accepted: e.target.checked,
                    });
                    // this.Step2Validation()
                  }}
                />
                <label htmlFor="term">
                  <p className=" sub_title  mb-0 font-weight-700 term_service_subtitle">
                    By signing up, I grant my permission for DoodyCalls to
                    access my property. I acknowledge that I have read and agree
                    to the{" "}
                    <a
                      href="https://www.doodycalls.com/terms-of-service/"
                      target="_blank"
                    >
                      <b className="term_service_subtitle">Terms of Service</b>
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://www.doodycalls.com/privacy-policy/"
                      target="_blank"
                    >
                      <b className="term_service_subtitle">Privacy Policy</b>
                    </a>
                    .I understand that the{" "}
                    <a
                      href="https://www.doodycalls.com/terms-of-service/"
                      target="_blank"
                    >
                      <b className="term_service_subtitle">Terms of Service</b>
                    </a>{" "}
                    will continue and remain in effect, with the same services
                    to be provided each year at the then-effectiveprice and
                    under the same payment plan I have selected, unless and
                    until I cancel or modify my services. I understand that I
                    may cancel my services at any time, without penalty or
                    payment of a cancellation fee, by calling the local
                    DoodyCalls office at{" "}
                    <b className="term_service_underlined_bold">
                      1-800-366-3922
                    </b>
                    , by emailing{" "}
                    <a href="mailto:servicerequest@doodycalls.com">
                      <b className="term_service_subtitle">
                        servicerequest@doodycalls.com
                      </b>
                    </a>
                    , or by using the cancellation link in my{" "}
                    <a
                      href="https://app.doodycalls.com/account"
                      target="_blank"
                    >
                      <b className="term_service_subtitle">
                        Customer Account online
                      </b>
                    </a>
                    .
                  </p>
                </label>
              </div>
              {errors && errors["is_ternm_accepted"] ? (
                <label className="new_err_msg">
                  <i className="las la-info-circle"></i>{" "}
                  {errors["is_ternm_accepted"]}
                </label>
              ) : (
                ""
              )}
            </section>
            <div className="submit_btn mobile_continue_btn">
              <button
                type="button"
                onClick={() => {
                  this.Step2Validation(true)
                }}
                className="btn"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-1 d-lg-block d-md-none"></div>
        <div className="col-md-5 col-lg-4 sidebar_mobile_p_0">
          <Sidebar
            is_final_sidebar={this.props.is_final_sidebar}
            is_footer={this.props.is_footer}
            pricingCalculator={(e) => {
              this.props.pricingCalculator(e);
            }}
            PlaceServiceOrder={() => this.PlaceServiceOrder()}
            is_checkout_btn_active={is_checkout_btn_active}
            frequency={this.props.frequency}
            loader={loader}
            current={this.props.current}
            onPrepayChange={this.props.onPrepayChange}
            onPrepayTypeChange={this.props.onPrepayTypeChange}
            prepay_months={this.props.prepay_months}
            PricingCalc={this.props.PricingCalc}
            is_continue_btn_active={false}
            history={this.props.history}
            ZipcodeCheck={this.props.ZipcodeCheck}
            is_prepaid={this.props.is_prepaid}
            goToNextStep={() => this.goToNextStep()}
            Step2Validation={this.Step2Validation}
            // is_checkout_mobile_btn_active = {this.state.is_checkout_mobile_btn_active}
            setLoader={this.setLoader}
            is_order_placed={this.is_order_placed}
          />
        </div>
      </div>
    );
  }
}

export default Step2;
